/**
 * Collapsible section for organization.
 */
import * as React from 'react';
import { observer } from 'mobx-react';
const { Collapse } = require('react-collapse');

import './Section.css';

interface SectionProps {
    name: JSX.Element;
    onClick: (e: {}) => void;
    opened: boolean;
    style?: React.CSSProperties;
    borderColour?: string;
}

/**
 * Collapsible section for organization. 
 * Used for blacklist and taglist.
 *  
 * @export
 * @class Section
 * @extends {React.Component<SectionProps>}
 */
@observer
export class Section extends React.Component<SectionProps> {
    render() {
        return (
            <div style={this.props.style}>
                <div
                    style={{
                        borderColor: this.props.borderColour,
                    }}
                    className="Section-header" 
                    onClick={this.props.onClick}
                > 
                    {this.props.name} 
                </div>
                <Collapse isOpened={this.props.opened}>
                    {this.props.children}
                </Collapse>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Inputs/Section/Section.tsx